// extracted by mini-css-extract-plugin
export default {"keyOutput":"APIKeyForm_keyOutput__Jytgv","rolesTooltip":"APIKeyForm_rolesTooltip__mnQdp"};